<div>
    <a
        [routerLink]="['/admin']"
        class="flex cursor-pointer items-center gap-2 px-4 pt-2"
        (click)="navigated.emit()">
        <img
            src="assets/logo/hairstyleclub-icon.png"
            class="h-10 w-10 object-contain"
            alt="Hair Style Club" />
        <span
            class="text-lg font-bold tracking-tight text-gray-800 dark:text-white">
            Hair Style Club
        </span>
    </a>
</div>

<nav class="mt-4 px-2 pb-6" aria-label="Super admin">
    @for (group of navigationGroups; track group.label) {
        <p class="sidebar-nav-group-label">{{ group.label }}</p>
        <ul class="space-y-1">
            @for (item of group.items; track item.routerLink) {
                <li>
                    <a
                        [routerLink]="item.routerLink"
                        routerLinkActive="is-active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        #rla="routerLinkActive"
                        [attr.aria-current]="rla.isActive ? 'page' : null"
                        class="sidebar-nav-link"
                        (click)="navigated.emit()">
                        <ng-icon [name]="item.icon" class="sidebar-nav-icon" />
                        <span class="sidebar-nav-label">{{ item.label }}</span>
                    </a>
                </li>
            }
        </ul>
    }
</nav>
